import { render, staticRenderFns } from "./ApfEhSupportingDocument.vue?vue&type=template&id=16ff73e5"
import script from "./ApfEhSupportingDocument.vue?vue&type=script&lang=js"
export * from "./ApfEhSupportingDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports